import { render, staticRenderFns } from "./ProdutoModal.vue?vue&type=template&id=56ed658f&scoped=true"
import script from "./ProdutoModal.vue?vue&type=script&lang=js"
export * from "./ProdutoModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoModal.vue?vue&type=style&index=0&id=56ed658f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ed658f",
  null
  
)

export default component.exports